import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

type Props = {
  email: string
  text?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseEmail',
  props: {
    email: {},
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "base-email",
    href: `mailto:${props.email}`,
    target: "_self"
  }, _toDisplayString(_ctx.text ?? _ctx.email), 9, _hoisted_1))
}
}

})